import { render, staticRenderFns } from "./GongTongPage.vue?vue&type=template&id=e700ae18&scoped=true&"
import script from "./GongTongPage.vue?vue&type=script&lang=js&"
export * from "./GongTongPage.vue?vue&type=script&lang=js&"
import style0 from "./GongTongPage.vue?vue&type=style&index=0&id=e700ae18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e700ae18",
  null
  
)

export default component.exports